"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadCroppedImageRequest = uploadCroppedImageRequest;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

function uploadCroppedImageRequest(_x) {
  return _uploadCroppedImageRequest.apply(this, arguments);
}

function _uploadCroppedImageRequest() {
  _uploadCroppedImageRequest = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var fileBlob, csrf, pixelCrop, formData, response, data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileBlob = _ref.fileBlob, csrf = _ref.csrf, pixelCrop = _ref.pixelCrop;
            formData = new FormData();
            formData.append('image', fileBlob);

            if (typeof csrf === 'string') {
              formData.append('yip_csrf_token', csrf);
            }

            if (pixelCrop !== null) {
              formData.append('crop_coords[width]', String(Math.round(pixelCrop.width)));
              formData.append('crop_coords[height]', String(Math.round(pixelCrop.height)));
              formData.append('crop_coords[x]', String(Math.round(pixelCrop.x)));
              formData.append('crop_coords[y]', String(Math.round(pixelCrop.y)));
            }

            _context.next = 7;
            return fetch((0, _absoluteUrlRuntime.resolveUrl)('/attachment/new', _absoluteUrlRuntime.UrlSourceType.Api), {
              method: 'POST',
              body: formData
            });

          case 7:
            response = _context.sent;
            _context.next = 10;
            return response.json();

          case 10:
            data = _context.sent;

            if (!pixelCrop) {
              data.source_thumb = data.source;
            }

            return _context.abrupt("return", data);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _uploadCroppedImageRequest.apply(this, arguments);
}